import { UFS } from '@/shared/lib/endereco';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/shared/ui/select';

/** O `<Select>` do Radix não aceita `value=""`. */
export const TODAS_AS_UFS = 'todas';

export type ValorDoFiltroDeUf = (typeof UFS)[number] | typeof TODAS_AS_UFS;

/**
 * Filtro por estado dos relatórios. O estado do usuário é a UF do endereço da
 * clínica ou, sem endereço, a do CRMV — quem decide é o backend (`ufDoPerfil`).
 */
export function FiltroDeUf({
  valor,
  aoMudar,
}: {
  valor: ValorDoFiltroDeUf;
  aoMudar: (valor: ValorDoFiltroDeUf) => void;
}) {
  return (
    <Select value={valor} onValueChange={(v) => aoMudar(v as ValorDoFiltroDeUf)}>
      <SelectTrigger className="sm:w-44" aria-label="Filtrar por estado">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={TODAS_AS_UFS}>Todos os estados</SelectItem>
        {UFS.map((uf) => (
          <SelectItem key={uf} value={uf}>
            {uf}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
